<a class="carto" *ngIf="showCarto" href="https://carto.com/" target="_blank">
  <img src="/assets/latitude/carto_positive.svg" alt="carto" />
</a>
<div class="geo" [ngStyle]="{ 'height.px': size, 'width.px': size }">
  <a href="https://geographica.gs" target="_blank">
    <svg
      class="small"
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      enable-background="new 0 0 24 24"
      xml:space="preserve"
    >
      <g>
        <path
          d="M16.5,11.3H12v2.1h2.205c-0.058,1.327-0.228,1.778-0.605,2.196c-0.359,0.413-0.917,0.683-1.6,0.683
        s-1.258-0.27-1.617-0.683c-0.486-0.54-0.612-1.133-0.612-3.597c0-2.462,0.126-3.056,0.612-3.595
        C10.742,7.991,11.317,7.721,12,7.721s1.24,0.27,1.6,0.683c0.246,0.272,0.404,0.56,0.501,1.096h2.338
        c-0.105-1.145-0.39-1.922-1.148-2.678c-0.867-0.863-2.007-1.33-3.29-1.33s-2.423,0.467-3.29,1.33C7.5,8.026,7.5,9.285,7.5,11.999
        c0,2.716,0,3.974,1.21,5.179c0.867,0.861,2.007,1.33,3.29,1.33s2.423-0.469,3.29-1.33c1.21-1.205,1.21-2.463,1.21-5.179
        C16.5,11.755,16.5,11.521,16.5,11.3z"
        />
        <rect x="3" y="3" width="1.5" height="1.5" />
        <rect x="19.5" y="3" width="1.5" height="1.5" />
        <rect x="3" y="19.5" width="1.5" height="1.5" />
        <rect x="19.5" y="19.5" width="1.5" height="1.5" />
      </g>
    </svg>
    <svg
      class="arrow"
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="36px"
      height="36px"
      viewBox="0 0 36 36"
      enable-background="new 0 0 36 36"
      xml:space="preserve"
    >
      <polyline
        stroke-miterlimit="10"
        points="24.146,17.854 17.5,11.207 10.854,17.854 "
      />
      <line stroke-miterlimit="10" x1="17.5" y1="11.207" x2="17.5" y2="25.5" />
    </svg>
  </a>
  <svg
    class="big"
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="52px"
    height="68px"
    viewBox="0 0 52 68"
    enable-background="new 0 0 52 68"
    xml:space="preserve"
  >
    <g>
      <path
        d="M12.812,9.562H10v1.312h1.378c-0.036,0.829-0.143,1.111-0.378,1.372c-0.225,0.259-0.573,0.427-1,0.427
      s-0.787-0.168-1.012-0.427C8.686,11.91,8.607,11.539,8.607,10s0.078-1.91,0.381-2.247C9.213,7.494,9.573,7.326,10,7.326
      s0.775,0.168,1,0.427c0.153,0.17,0.252,0.35,0.312,0.685h1.461c-0.066-0.715-0.243-1.201-0.718-1.674
      C11.514,6.225,10.802,5.933,10,5.933S8.486,6.225,7.944,6.764C7.188,7.517,7.188,8.303,7.188,10s0,2.483,0.757,3.236
      c0.542,0.539,1.254,0.831,2.056,0.831s1.514-0.292,2.056-0.831c0.757-0.753,0.757-1.54,0.757-3.236
      C12.812,9.847,12.812,9.701,12.812,9.562z"
      />
      <path
        d="M12.812,25.562H10v1.312h1.378c-0.036,0.829-0.143,1.111-0.378,1.372c-0.225,0.259-0.573,0.427-1,0.427
      s-0.787-0.168-1.012-0.427C8.686,27.91,8.607,27.539,8.607,26s0.078-1.91,0.381-2.247c0.225-0.259,0.585-0.427,1.012-0.427
      s0.775,0.168,1,0.427c0.153,0.17,0.252,0.35,0.312,0.685h1.461c-0.066-0.715-0.243-1.201-0.718-1.674
      c-0.542-0.539-1.254-0.831-2.056-0.831s-1.514,0.292-2.056,0.831C7.188,23.517,7.188,24.303,7.188,26s0,2.483,0.757,3.236
      c0.542,0.539,1.254,0.831,2.056,0.831s1.514-0.292,2.056-0.831c0.757-0.753,0.757-1.54,0.757-3.236
      C12.812,25.847,12.812,25.701,12.812,25.562z"
      />
      <path
        d="M23.188,14V6h5.625v1.394h-4.063V9.27h3.501v1.394h-3.501v1.943h4.063V14H23.188z"
      />
      <path
        d="M44.056,6.764C43.514,6.225,42.802,5.933,42,5.933s-1.514,0.292-2.056,0.831
      c-0.757,0.753-0.757,1.54-0.757,3.236s0,2.483,0.757,3.236c0.542,0.539,1.254,0.831,2.056,0.831s1.514-0.292,2.056-0.831
      c0.757-0.753,0.757-1.54,0.757-3.236S44.812,7.517,44.056,6.764z M43,12.247c-0.225,0.259-0.573,0.427-1,0.427
      s-0.787-0.168-1.012-0.427c-0.303-0.337-0.381-0.708-0.381-2.247s0.078-1.91,0.381-2.247C41.213,7.494,41.573,7.326,42,7.326
      s0.775,0.168,1,0.427C43.304,8.09,43.394,8.461,43.394,10S43.304,11.91,43,12.247z"
      />
      <path
        d="M29.325,30l-1.7-3.282c0.873-0.415,1.367-1.263,1.367-2.224c0-1.359-0.989-2.494-2.641-2.494h-3.164v8
      h1.562v-3.011h1.293L27.516,30H29.325z M24.749,23.394h1.523c0.708,0,1.157,0.449,1.157,1.101c0,0.652-0.449,1.09-1.157,1.09
      h-1.523V23.394z"
      />
      <path
        d="M43.783,30l-0.443-1.416h-2.669L40.217,30h-1.529l2.732-8h1.149l2.743,8H43.783z M42.031,24.359
      l-0.949,2.91h1.867L42.031,24.359z"
      />
      <path
        d="M27.251,46v-3.349h-2.502V46h-1.562v-8h1.562v3.27h2.502V38h1.562v8H27.251z"
      />
      <path
        d="M10.352,42.988H8.749V46H7.188v-8h3.164c1.651,0,2.641,1.135,2.641,2.494S12.003,42.988,10.352,42.988z
      M10.272,39.394H8.749v2.19h1.523c0.708,0,1.157-0.438,1.157-1.09C11.43,39.843,10.98,39.394,10.272,39.394z"
      />
      <polygon
        points="42.781,44.606 42.781,39.394 44.281,39.394 44.281,38 39.719,38 39.719,39.394 41.219,39.394
      41.219,44.606 39.562,44.606 39.562,46 44.438,46 44.438,44.606 		"
      />
      <path
        d="M11.314,59.551c-0.061,0.343-0.159,0.523-0.314,0.696c-0.225,0.259-0.573,0.427-1,0.427
      s-0.787-0.168-1.012-0.427C8.686,59.91,8.606,59.539,8.606,58s0.079-1.91,0.382-2.247c0.225-0.259,0.585-0.427,1.012-0.427
      s0.775,0.168,1,0.427c0.153,0.171,0.252,0.35,0.312,0.685h1.461c-0.066-0.715-0.243-1.201-0.718-1.674
      c-0.542-0.539-1.254-0.831-2.056-0.831s-1.514,0.292-2.056,0.831C7.188,55.517,7.188,56.303,7.188,58s0,2.483,0.757,3.236
      c0.542,0.539,1.254,0.831,2.056,0.831s1.514-0.292,2.056-0.831c0.478-0.475,0.653-0.964,0.719-1.686H11.314z"
      />
      <rect x="41.219" y="57.219" width="1.562" height="1.562" />
      <path
        d="M27.783,62l-0.443-1.416h-2.669L24.217,62h-1.529l2.732-8h1.149l2.743,8H27.783z M26.031,56.359
      l-0.949,2.91h1.867L26.031,56.359z"
      />
      <rect x="1.625" y="1.625" width="0.75" height="0.75" />
      <rect x="17.625" y="1.625" width="0.75" height="0.75" />
      <rect x="33.625" y="1.625" width="0.75" height="0.75" />
      <rect x="49.625" y="1.625" width="0.75" height="0.75" />
      <rect x="1.625" y="17.625" width="0.75" height="0.75" />
      <rect x="17.625" y="17.625" width="0.75" height="0.75" />
      <rect x="33.625" y="17.625" width="0.75" height="0.75" />
      <rect x="49.625" y="17.625" width="0.75" height="0.75" />
      <rect x="1.625" y="33.625" width="0.75" height="0.75" />
      <rect x="17.625" y="33.625" width="0.75" height="0.75" />
      <rect x="33.625" y="33.625" width="0.75" height="0.75" />
      <rect x="49.625" y="33.625" width="0.75" height="0.75" />
      <rect x="1.625" y="49.625" width="0.75" height="0.75" />
      <rect x="17.625" y="49.625" width="0.75" height="0.75" />
      <rect x="33.625" y="49.625" width="0.75" height="0.75" />
      <rect x="49.625" y="49.625" width="0.75" height="0.75" />
      <rect x="1.625" y="65.625" width="0.75" height="0.75" />
      <rect x="17.625" y="65.625" width="0.75" height="0.75" />
      <rect x="33.625" y="65.625" width="0.75" height="0.75" />
      <rect x="49.625" y="65.625" width="0.75" height="0.75" />
    </g>
  </svg>
</div>
